import * as React from 'react';
import { Prompt } from 'react-router';
import { formValueSelector, reduxForm } from 'redux-form';
import { Card } from 'material-ui/Card';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps } from 'recompose';
import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';

import { getBicycle } from '@modules/bicycles/_bicyclesActions';
import * as T from '@modules/bicycles/_bicyclesTypes';
import { BicycleFormBasic } from '@modules/bicycles/BicycleFormBasic';
import { connect } from 'react-redux';

export const enhance = compose<T.BicycleProps, T.Outter>(
  entityDetailEnhancer<T.BicycleEnhancerProps<T.Bicycle>, T.Bicycle>({
    getEntity: getBicycle,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [
    { label: 'Kola', to: '/bicycles' },
    { label: entity && entity.id ? 'Nový záznam' : 'Upravit záznam' }
  ]),
  withProps<{}, T.BicycleProps>(({ entity }) => ({
    initialValues: {
      photos: [],
      ...entity
    }
  })),
  connect(state => {
    return {
      photos: formValueSelector('module-bicycles')(state, 'photos')
    };
  }),
  reduxForm({
    form: 'module-bicycles'
  })
);

export const View: React.SFC<T.Outter & T.BicyclesFormProps> = ({ handleSubmit, closeItem, photos, ...props }) => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={handleSubmit}>
      <Card>
        <BicycleFormBasic />

        <Button
          type="submit"
          label="Uložit a zavřít"
          primary={true}
          style={{ margin: '16px 0 16px 16px' }}
          disabled={photos && photos.length > 10}
        />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);

export const BicyclesForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/bicycles/BicyclesForm.tsx